import { z } from 'zod'
import { CurrencySchema } from '@shared/contracts/enums'

export const ReceivingPlanFeeSchema = z.object({
  currency: CurrencySchema,
  nationalFeePercentage: z.string(),
  internationalFeePercentage: z.string(),
  pixFeePercentage: z.string(),
  nationalReservePercentage: z.string(),
  globalReservePercentage: z.string(),
  nationalReserveDays: z.number().int(),
  globalReserveDays: z.number().int(),
  nationalFixedFee: z.string(),
  internationalFixedFee: z.string(),
})
export const UserReceivingPlanSchema = z.object({
  serviceFee: z.object({ percentage: z.string(), fixedUsd: z.string() }).optional(),
  versionId: z.string().nullable(),
  defaultVersionId: z.string().nullable().optional(),
  kind: z.enum(['STANDARD', 'CUSTOM']),
  receivingPeriod: z.enum(['D2', 'D5', 'D14', 'D30']),
  receivingDays: z.number().int(),
  withdrawalFeeBrl: z.string(),
  withdrawalFees: z.partialRecord(CurrencySchema, z.string()).optional(),
  effectiveFrom: z.string().nullable(),
  fees: z.array(ReceivingPlanFeeSchema).min(1),
  overrides: z
    .object({
      fees: z.record(CurrencySchema, z.array(z.string())).optional(),
      withdrawalFees: z.array(CurrencySchema),
    })
    .optional(),
})
export const ReceivingPlansResponseSchema = z.object({
  current: UserReceivingPlanSchema,
  standards: z.array(UserReceivingPlanSchema),
  history: z
    .array(
      z.object({
        versionId: z.string(),
        kind: z.enum(['STANDARD', 'CUSTOM']),
        receivingPeriod: z.string(),
        receivingDays: z.number(),
        withdrawalFeeBrl: z.string(),
        withdrawalFees: z.partialRecord(CurrencySchema, z.string()).optional(),
        effectiveFrom: z.string(),
        actorId: z.string(),
        actorName: z.string().nullable().optional(),
        actorType: z.enum(['STAFF', 'SELLER']),
        reason: z.string(),
        previousVersionId: z.string().nullable(),
        serviceFee: z.object({ percentage: z.string(), fixedUsd: z.string() }).optional(),
      }),
    )
    .optional(),
})
export const DefaultReceivingPlanSchema = UserReceivingPlanSchema.extend({
  history: z.array(
    z.object({
      versionId: z.string(),
      effectiveFrom: z.string(),
      actorName: z.string(),
      reason: z.string(),
    }),
  ),
})
export type UserReceivingPlan = z.infer<typeof UserReceivingPlanSchema>
export type ReceivingPlanFee = z.infer<typeof ReceivingPlanFeeSchema>
export type ReceivingPlansResponse = z.infer<typeof ReceivingPlansResponseSchema>
export const planName = (plan: UserReceivingPlan) =>
  plan.kind === 'CUSTOM' ? 'Personalizado' : 'Padrão'
export const planPercent = (value: string) =>
  `${new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 3 }).format(Number(value))}%`
